import { Avatar, Box, Chip, Typography } from "@mui/material";

import { formatName } from "../lib/formatName";
import { avatarSize, color, ContainerMaxWidth, space, typography } from "../theme/designTokens";

export interface UserRecord {
  id: string;
  avatarUrl?: string | null;
  name?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  status?: string;
}

interface UserAvatarProps {
  record: UserRecord;
}

const UserAvatar = ({ record }: UserAvatarProps) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        minWidth: 0,
        maxWidth: "100%",
        width: { xs: "100%", sm: "auto" },
        p: { xs: `${space.xs}px`, sm: space.xs },
      }}
    >
      <Avatar
        src={record.avatarUrl ?? undefined}
        alt={record.name ?? undefined}
        sx={{ width: avatarSize.lg, height: avatarSize.lg, flexShrink: 0 }}
      />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          marginLeft: { xs: `${space.xs}px`, sm: space.xs },
          minWidth: 0,
          maxWidth: ContainerMaxWidth.sm,
        }}
      >
        <Typography
          variant="h5"
          component="h1"
          sx={{
            fontWeight: typography.fontWeight.medium,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: { xs: "normal", sm: "nowrap" },
            overflowWrap: "anywhere",
          }}
          title={formatName(record) ?? undefined}
        >
          {formatName(record)}
        </Typography>

        <Box sx={{ display: "flex", gap: space.xxs, mt: space.xxs, flexWrap: "wrap" }}>
          {record?.status && (
            <Chip label={record.status === "ACTIVE" ? "Aktiv" : "Inaktiv"} sx={{ backgroundColor: color.chipColor }} />
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default UserAvatar;
